import { useEventNameMatch } from '@shared/components/AuthProvider/AuthProvider.utils';
import { EventType } from '@graphql/generated-base';
import { useGuestIdentificationEligibilityQuery } from './GuestIdentificationDialog.graphql.generated';

export const useGuestIdentificationDialogController = ({ skip }: { skip?: boolean } = {}) => {
  const { eventName } = useEventNameMatch();

  // The provider always mounts this hook to keep the React subtree stable
  // across feature-flag / iframe / preview gate transitions; `skip` is how
  // the provider tells the controller to stay inert when those gates fail.
  const { data } = useGuestIdentificationEligibilityQuery({
    variables: { eventHandle: eventName || '' },
    batchMode: 'fast',
    ssr: false,
    skip: skip || !eventName,
  });

  const event = data?.eventByName;
  const eventType = event?.info?.eventType;
  const activeSession = event?.activeSession;
  const hasIdentity = activeSession?.hasIdentity;
  const personFullName = activeSession?.person?.fullName;
  const eventId = event?.id ?? '';

  // True when the current visitor is a candidate for email-based identification:
  // a general event with no active session identity. Whether we auto-open the
  // dialog or show the sticky "Find your invitation" button is decided
  // downstream based on dismissal state.
  const canIdentifyGuest = eventType === EventType.general && !hasIdentity && !personFullName?.length && !!eventId;

  return {
    canIdentifyGuest,
    eventId,
    eventName: eventName ?? '',
  };
};
